import React from "react";
import { motion } from "framer-motion";
import { Award, MapPinned, Smile, Sunrise } from "lucide-react";
import Counter from "./Counter";

const stats = [
  { label: "Happy Customers", value: 250, icon: Smile },
  { label: "Daily Yoga Sessions", value: 150, icon: Sunrise },
  { label: "Certified Trainers", value: 10, icon: Award },
  { label: "Yoga Centers", value: 2, icon: MapPinned },
];

const StatsSection = () => {
  return (
    <section className="ym-section-tight ym-section-band">
      <div className="ym-container ym-grid-4">
        {stats.map((item, index) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={item.label}
              className="ym-card ym-stat"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ delay: index * 0.08 }}
              whileHover={{ y: -5 }}
            >
              <span className="ym-icon-box" style={{ marginBottom: 16,alignItems:"center",display:"flex" }}>
                <Icon size={22} />
              </span>
              <strong>
                <Counter target={item.value} duration={1800} />+
              </strong>
              <span>{item.label}</span>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default StatsSection;
